var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4987 21.5625C10.6904 21.5625 11.6654 20.5875 11.6654 19.3958H7.33203C7.33203 20.5875 8.30703 21.5625 9.4987 21.5625ZM15.9987 15.0625V9.64583C15.9987 6.32 14.2329 3.53583 11.1237 2.79917V2.0625C11.1237 1.16333 10.3979 0.4375 9.4987 0.4375C8.59953 0.4375 7.8737 1.16333 7.8737 2.0625V2.79917C4.77536 3.53583 2.9987 6.30917 2.9987 9.64583V15.0625L0.832031 17.2292V18.3125H18.1654V17.2292L15.9987 15.0625ZM13.832 16.1458H5.16536V9.64583C5.16536 6.95917 6.8012 4.77083 9.4987 4.77083C12.1962 4.77083 13.832 6.95917 13.832 9.64583V16.1458Z",
    fill: "#1D5E6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.0b3f74868fd543cb793241d46175aade.svg";
export { ForwardRef as ReactComponent };